<swiper [config]="configCarousel">
  <ng-template *ngFor="let category of categories" class="swiper-slide" swiperSlide>
    <a *ngIf="!category.ocultar" [routerLink]="'/' + category.fullIdExterno">
      <div class="title fs-5">{{category.nombre}}</div>
      <img src="{{category.imgUrl}}" alt="{{category.nombre}}">
    </a>
  </ng-template>
</swiper>